import React,{useState} from 'react';
import {Link} from 'react-router-dom';

const Navbar = () => {
    const [click, setClick] = useState(false);
   
    const handleClick = () => setClick(!click);
    const closeMoblieMenu = () => setClick(false);

    return (
        <>
        <nav className='navbar'>
        <div className='navbar-container'>
       
        <div to='/' className='navbar-logo'>
            <div className="Flogo"><img className='Fimage' src='./logo.jpg'/></div>
          {/* <img className='img-logo' src={process.env.PUBLIC_URL + '/R-logo.png'} alt='R'/> */}
        </div>
        <div className='search'>
        <i class="fa fa-search" aria-hidden="true"></i>
            </div>
        <div className='menu-icon' onClick={handleClick}>
          <i className= {click ? 'fas fa-times' : 'fas fa-bars'} />
        </div>
        
        <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className='nav-item'>
                <Link to='/' className='nav-links' onClick={closeMoblieMenu}>
                <i className= 'fas fa-home' aria-hidden="true" />
                <span className='title'>Home</span>
                </Link>
            </li>
            <li className='nav-item'>
                <Link to="/education" className='nav-links' onClick={closeMoblieMenu}>
               
                <i class="fa fa-user-circle" aria-hidden="true"></i>
                <span className='title'>Friends</span>
                </Link>
            </li>
            <li className='nav-item'>
                <Link to='/work' className='nav-links' onClick={closeMoblieMenu}>
                <i class="fa fa-video-camera" aria-hidden="true"></i>
                <span className='title'>Video</span>
                </Link>
            </li>
            <li className='nav-item'>
                <Link to='/exprience' className='nav-links' onClick={closeMoblieMenu}>
                <i class="fa fa-users" aria-hidden="true"></i>
                <span className='title'>Group</span>
                </Link>
            </li>
            <li className='nav-item'>
                <Link to='/contact' className='nav-links' onClick={closeMoblieMenu}>
                <i class="fa fa-gamepad" aria-hidden="true"></i>
                <span className='title'>Gaming</span>
                </Link>
            </li>
           

        </ul>
        
        </div> 
    </nav>
    </>
    )
}

export default Navbar
